module.exports = __webpack_public_path__ + "img/admin-portal-tooltip.e7dbbfa1.png";